import { defaultTableTheme } from '../GlobalStyles/TableTheme';
import React from 'react';
import MUIDataTable from 'mui-datatables';
import { ThemeProvider } from '@mui/material';
import { defaultOptions } from '../GlobalStyles/MUIDefaultSettings';

const TableBase = ({key, title, data, columns, options, components}) => {
    //key field is used to cause a rerender when using custom footer
    return (
        <ThemeProvider theme={defaultTableTheme}>
            <MUIDataTable
                key={key}
                title={title}
                data={data}
                columns={columns}
                options={options?options:defaultOptions}
                components={components}
            />
        </ThemeProvider>
    )

}

export default TableBase